export default "__VITE_ASSET__4EdNpDWr__"